import * as Yup from 'yup';
import { Actions } from './index';

export interface ApiApp {
  readonly clientId: string;
  readonly parentUrl: string;
  readonly ownerId: number;
}

export const apiAppSchema = Yup.object<ApiApp>({
  clientId: Yup.string().trim().required(),
  parentUrl: Yup.string().trim().required(),
  ownerId: Yup.number().required(),
})
  .notRequired()
  .default(undefined);

export interface UpdateApiAppAction {
  type: Actions.UpdateApiApp;
  payload: ApiApp;
}

export type ApiAppActions = UpdateApiAppAction;
